module.exports = __webpack_public_path__ + "static/media/back.edfeea25.png";